function DateRangeRequired (value, attrValue) {
    if (value || attrValue>0) {
        return true;
    }
    return false;
}

export default DateRangeRequired;
